import { useState } from "react";
import { faqs } from "@/mocks/movieData";
import SectionHeading, { Section } from "./SectionHeading";

export default function FaqSection() {
  const [openId, setOpenId] = useState<string | null>(faqs[0]?.id ?? null);

  return (
    <Section id="faq" className="bg-background-100">
      <SectionHeading
        eyebrow="使用指南"
        accent="secondary"
        title="打不开、加载慢、要不要装 APP，一次说清"
        description="下面这些问题覆盖了大多数使用场景。点击标题即可展开或收起对应答案，多条可以同时打开对照查看。"
      />

      <div className="space-y-3">
        {faqs.map((faq, index) => {
          const isOpen = openId === faq.id;
          return (
            <div
              key={faq.id}
              className={`rounded-lg bg-background-50 border overflow-hidden transition-colors ${
                isOpen ? "border-primary-300" : "border-background-200"
              }`}
            >
              <h3>
                <button
                  type="button"
                  onClick={() => setOpenId(isOpen ? null : faq.id)}
                  aria-expanded={isOpen}
                  aria-controls={`faq-panel-${faq.id}`}
                  id={`faq-button-${faq.id}`}
                  className="w-full flex items-center gap-4 text-left px-4 md:px-5 py-4 cursor-pointer hover:bg-background-100 transition-colors"
                >
                  <span className="shrink-0 w-8 h-8 flex items-center justify-center rounded-full bg-primary-100 text-primary-700 text-sm font-label">
                    {String(index + 1).padStart(2, "0")}
                  </span>
                  <span className="flex-1 font-heading text-base md:text-lg font-bold text-foreground-950">
                    {faq.q}
                  </span>
                  <i
                    className={`shrink-0 text-xl transition-transform duration-300 ${
                      isOpen ? "ri-subtract-line text-primary-600 rotate-0" : "ri-add-line text-foreground-400"
                    }`}
                    aria-hidden="true"
                  ></i>
                </button>
              </h3>
              <div
                id={`faq-panel-${faq.id}`}
                role="region"
                aria-labelledby={`faq-button-${faq.id}`}
                className={`px-4 md:px-5 overflow-hidden transition-all duration-300 ${
                  isOpen ? "max-h-96 pb-5" : "max-h-0"
                }`}
              >
                <p className="pl-12 text-sm md:text-base text-foreground-600 leading-relaxed">{faq.a}</p>
              </div>
            </div>
          );
        })}
      </div>
    </Section>
  );
}